import { requireStringField } from "./ReplayPayloadValidation";

/**
 * Validation for "bonus_feature_won".
 *
 * Payload:
 * - featureIdentifier (required)
 * - featureCountAwarded (required)
 */
export function parseBonusFeatureWonPayload(actionTypeName: string, payload: Record<string, unknown>): {
  featureIdentifier: string;
  featureCountAwarded: string;
} {
  const featureIdentifier = requireStringField(actionTypeName, payload, "featureIdentifier");
  const featureCountAwarded = requireStringField(actionTypeName, payload, "featureCountAwarded");

  return { featureIdentifier, featureCountAwarded };
}